import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import type { MigrationStatus } from "@/lib/org-structure-tree";

/** Mesma paleta de `OrgUnitPlayButton` — pendente/rodando/feito/falhou/etc.
 * têm que ser reconhecíveis pela cor em toda a tela do Nó 02, não só no play. */
const STATUS_LABEL: Record<MigrationStatus, string> = {
  pending: "Pending",
  running: "Running",
  completed: "Completed",
  failed: "Failed",
  interrupted: "Interrupted",
  awaiting_human_decision: "Awaiting decision",
};

const STATUS_CLASS: Record<MigrationStatus, string> = {
  pending: "bg-[#e8f0fc] text-[#1769e0]",
  running: "bg-[#fdf3e0] text-[#e0a115]",
  completed: "bg-[#e6f5ee] text-[#1b8a5a]",
  failed: "bg-[#fbe9e7] text-[#c0392b]",
  interrupted: "bg-[#fdf1e0] text-[#e08a15]",
  awaiting_human_decision: "bg-[#fdf1e0] text-[#e08a15]",
};

/** Selo de status do cadastro no CBC — ao lado do título do drawer de
 * detalhes (`OrgNodeDetailDrawer`), pra saber o estado da unidade sem
 * precisar rolar até o log de execução. */
export function OrgUnitStatusBadge({ status, label }: {
  status: MigrationStatus;
  /** Rótulo já traduzido no lugar do padrão (a Execução diz "Waiting for you"). */
  label?: string;
}) {
  const { t } = useTranslation();

  return (
    <Badge
      data-testid="org-unit-status-badge"
      variant="outline"
      className={`border-transparent font-mono text-[10px] uppercase tracking-[0.06em] ${STATUS_CLASS[status]}`}
    >
      {label ?? t(STATUS_LABEL[status])}
    </Badge>
  );
}
